<template>
  <v-app>
    <div
      class="preloader"
      v-bind:hidden="!showPreloader"
    >
      <img
        class="lipi-shop-logo"
        src="./assets/lipi-logo.png"
      />
    </div>
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",
  mounted() {
    window.setTimeout(() => {
      this.showPreloader = false;
    }, 4000);
    {
      let hundredVhFixFn = () => {
        // We execute the same script as before
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
      };
      window.addEventListener("resize", hundredVhFixFn);
      hundredVhFixFn();
    }
  },
  data() {
    return {
      showPreloader: true
    };
  }
};
</script>

<style scoped>
.preloader {
  height: 100vh;
  width: 100vw;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #b2dfdb;
  position: fixed;
  z-index: 99999;
  animation-iteration-count: 1;
  animation-duration: 4s;
  animation-name: slidein;
}

.lipi-shop-logo {
  /* margin: 2px 8px; */
  /* margin-right: 4px; */
  /* margin-left: 4px; */
  margin-left: calc(50vw - 70px);
  margin-top: calc(50vh - 70px);
  height: 140px;
  width: 140px;
}

@keyframes slidein {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>